import { boolean, defineAction, enumerated, object, string } from '~/prix'
import agentRequestResponseAction from './agentRequestResponse.action.json'

const agentRequestResponseDefinition = defineAction({
  ...agentRequestResponseAction,
  input: object({
    agentCpf: string(),
    entrepreneurCpf: string(),
    response: enumerated({
      accepted: 'accepted',
      refused: 'refused',
    }),
  }),
  output: object({
    success: boolean(),
  }),
})

export default agentRequestResponseDefinition
